/**
 * @function genErrorInfo
 * @function validate
 * @class ItemListValue
 */
export const FormHelper = {
     /**
      * @param {Number} formCount Number of input in form
      * @returns
      */
    genErrorInfo: function(formCount) {
        let errorInfo = [];
         for (let i = 0; i < formCount; i++) {
            let info = new ErrorInfo();
            errorInfo.push(info);

        }
        return errorInfo;
    },
    getFirstErrorItem: function (errorInfo) {
        for (let i of errorInfo) {
            if (!i.isValid) {
                return i;
            }
        }

        return null;
    },
    validate: function(errorInfo) {
        for (let i of errorInfo) {
            if (!i.isValid) {
                return false;
            }
        }
        return true;
    },
};

export function ErrorInfo() {
    this.isValid = true;
    this.msg = '';

    this.setValid = function (valid) {
        this.isValid = valid;
    };

    this.setMsg = function (msg) {
        this.msg = msg
    };
}


export function DropdownListValue() {
    this.list = [];
}

/**
 * 
 * @param {*} text 
 * @param {*} value 
 * @returns 
 */
DropdownListValue.prototype.add = function(text, value, extra = null){
    let obj = {
        text: text,
        value: value,
    }
    if(extra != null){
        obj.extra = extra
    }
    this.list.push(obj);
    return this
}

DropdownListValue.prototype.getList = function(){
    return this.list
}
